"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M18.92 2.01C18.72 1.42 18.16 1 17.5 1h-11c-.66 0-1.21.42-1.42 1.01L3 8v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8zM6.85 3h10.29l1.08 3.11H5.77zM19 13H5V8h14z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "7.5",
  cy: "10.5",
  r: "1.5"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "16.5",
  cy: "10.5",
  r: "1.5"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M7 20h4v-2l6 3h-4v2z"
}, "3")], 'ElectricCarOutlined');